import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getTransmissionAnalytic = async (filter) => {
  const { startDate, endDate } = filter;

  if (startDate && endDate) {
    const query = Object.entries(filter)
      .filter(([_, v]) => v)
      .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      .join("&");

    let url = endpoints.dashboard.transmissionAnalytic;
    url += query ? `?${query}` : "";

    const { data } = await api.get(url);
    return data;
  }
};
